import { identity } from 'ramda'

export const files = identity
